import React, { useCallback, useEffect, useState } from "react";
import { Container, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "react-image-gallery/styles/css/image-gallery.css";
import "react-rater/lib/react-rater.css";
import ImageProduct from "../../../components/store/product_detail/ImageProduct";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { useSelector } from "react-redux";
import BreadCrumbsProduct from "../../../components/store/product_detail/BreadCrumbsProduct";
import { useNavigate, useParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import { getPrice, getValByLang, stripHtml, truncate, allDomain } from "../../../utils/helpers";
import { useDispatch } from "react-redux";
import {
  loadSingleProductAsync,
  setDetailsSelected,
  setProductDetails,
} from "../../../services/store/storeSlice";
import { CircularProgress } from "@mui/material";
import Translation from "../../../utils/Translation";
import CartWithQuantity from "../../../components/store/product_detail/CartWithQuantity";
import AllDetails from "../../../components/store/product_detail/AllDetails";
import ShowPrice from "../../../components/store/product_detail/ShowPrice";
import DescriptionProduct from "../../../components/store/product_detail/DescriptionProduct";
import SellerProduct from "../../../components/store/product_detail/SellerProduct";
import bannerSeller from "../../../assets/image/product/banner-seller-deliverit.webp";
import {
  mergeWithoutDuplicates,
  checkEqualArray,
  allLinks,
} from "../../../utils/helpers";
import Review from "../../../components/store/product_detail/Review";
import ProductRelated from "../../../components/store/product_detail/ProductRelated";
import AddToCartButton from "../../../components/store/action/AddToCartButton";
import { Helmet } from "react-helmet";

export default function ProductDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const dynamicState = useSelector((state) => state.dynamicConfig);
  const { language } = useSelector((state) => state.global);
  let textDesc = '';
  let pageTitle = '';
  const { slug } = useParams();
  const {
    productDetails,
    isLoading,
    detailsSelected,
    attributesLoaded,
    brands,
    tags,
    colors,
    sizes,
    custom_attributes,
    productReviews,
    stores,
  } = useSelector((state) => state.store);
  const id = productDetails?.id;
  const [quantity, setQuantity] = useState(1);
  const [galleryImage, setGalleryImage] = useState(null);
  const [localDetailsSelected, setLocalDetailsSelected] = useState({});
  const [attributesAvailable, setAttributesAvailable] = useState({
    Color: [],
    Size: [],
    Custom_Value: [],
  });
  const [attributesSelected, setAttributesSelected] = useState({
    Color: [],
    Size: [],
    Custom_Value: [],
  });
  const [readyForShowAttr, setReadyForShowAttr] = useState(false);
  const [priorityAttr, setPriorityAttr] = useState("color");
  const [priorityAttrIds, setPriorityAttrIds] = useState([]);

  const removeDuplicatedValue = (object) => {
    return object.filter(
      (val, index, self) =>
        index ===
        self.findIndex(
          (obj) => obj !== undefined && val !== undefined && obj.id === val.id
        )
    );
  };

  const getConditionsForPrimaryAttr = (
    obj,
    attrName,
    attributesSelectedLast
  ) => {
    if (String(attrName) === priorityAttr) return true; // clicked on primary attributes
    if (
      priorityAttr === "color" &&
      obj.color_id === attributesSelectedLast.Color[0]
    )
      return true;
    if (
      priorityAttr === "size" &&
      obj.size_id === attributesSelectedLast.Size[0]
    )
      return true;

    if (priorityAttr !== "color" && priorityAttr !== "size") {
      let primaryAttrIdObject = priorityAttrIds.values.filter((val) =>
        attributesSelectedLast.Custom_Value.includes(val.value_id)
      )[0];
      return obj.custom_attribute_values.includes(primaryAttrIdObject.value_id)
        ? true
        : false;
    }

    return false;
  };

  const getAttributesAvailable = useCallback(
    (detailsSelected, priorityAttrParam, priorityAttrIdsParam) => {
      let newDetails = [];
      let newCustomValue = [];

      if (productDetails?.id && priorityAttrParam !== undefined) {
        if (priorityAttrParam === "color") {
          newDetails = productDetails.details.filter(
            (val) => val.color_id === detailsSelected.color_id
          );
          for (var i = 0; i < newDetails.length; i++)
            newCustomValue = mergeWithoutDuplicates(
              newCustomValue,
              newDetails[i].custom_attribute_values
            );

          (newDetails.length > 0 ||
            newCustomValue.length > 0) &&
            setAttributesAvailable({
              Color: productDetails.details.map((val) => val.color_id),
              Size: newDetails.map((val) => val.size_id),
              Custom_Value: newCustomValue,
            });
        } else if (priorityAttrParam === "size") {
          newDetails = productDetails.details.filter(
            (val) => val.size_id === detailsSelected.size_id
          );
          for (var i = 0; i < newDetails.length; i++)
            newCustomValue = mergeWithoutDuplicates(
              newCustomValue,
              newDetails[i].custom_attribute_values
            );

          (newDetails.length > 0 ||
            newCustomValue.length > 0) &&
            setAttributesAvailable({
              Color: newDetails.map((val) => val.color_id),
              Size: productDetails.details.map((val) => val.size_id),
              Custom_Value: newCustomValue,
            });
        } else if (priorityAttrIdsParam) {

          let primaryAttrIdObject = priorityAttrIdsParam.values.filter((val) =>
            detailsSelected.custom_attribute_values.includes(val?.value_id)
          )[0];
          newDetails = productDetails.details.filter((val) =>
            val.custom_attribute_values.includes(primaryAttrIdObject?.value_id)
          );
          for (var i = 0; i < newDetails.length; i++)
            newCustomValue = mergeWithoutDuplicates(
              newCustomValue,
              newDetails[i].custom_attribute_values
            );

          (newDetails.length > 0 ||
            newCustomValue.length > 0) &&
            setAttributesAvailable({
              Color: newDetails.map((val) => val.color_id),
              Size: newDetails.map((val) => val.size_id),
              Custom_Value: newCustomValue,
            });
        }
      }
    },
    [dispatch, productDetails]
  );

  const setAllDetailsProduct = useCallback(() => {
    let productAllDetails = {
      ...productDetails,
      brands_array: [],
      tags_array: [],
      colors_array: [],
      sizes_array: [],
      attributes_array: [],
      sellerInfo: stores.filter((val) => val.id === productDetails.store_id),
    };

    productAllDetails.brands_array = brands.filter(
      (val) => productDetails.brands.includes(val.id) && val !== undefined
    );
    productAllDetails.tags_array = tags.filter(
      (val) => productDetails.tags.includes(val.id) && val !== undefined
    );

    for (var i = 0; i < productAllDetails.details.length; i++) {
      productAllDetails.colors_array[i] = colors.filter(
        (val) =>
          val.id === productAllDetails.details[i].color_id &&
          productAllDetails.details[i].color_id !== null
      )[0];
      productAllDetails.sizes_array[i] = sizes.filter(
        (val) =>
          val.id === productAllDetails.details[i].size_id &&
          productAllDetails.details[i].size_id !== null
      )[0];
      productAllDetails.attributes_array[i] = custom_attributes.filter(
        (val) =>
          productAllDetails.details[i].custom_attribute_keys.includes(val.id) &&
          productAllDetails.details[i].custom_attribute_keys.length !== 0
      );
    }

    // remove unique colors
    productAllDetails.brands_array = removeDuplicatedValue(
      productAllDetails.brands_array
    );
    productAllDetails.tags_array = removeDuplicatedValue(
      productAllDetails.tags_array
    );
    productAllDetails.colors_array = removeDuplicatedValue(
      productAllDetails.colors_array
    );
    productAllDetails.sizes_array = removeDuplicatedValue(
      productAllDetails.sizes_array
    );

    dispatch(setProductDetails(productAllDetails));
    (productAllDetails.brands_array.length > 0 ||
      productAllDetails.tags_array.length > 0 ||
      productAllDetails.colors_array.length > 0 ||
      productAllDetails.sizes_array.length > 0 ||
      productAllDetails.attributes_array.filter((val) => val.length > 0)
        .length > 0) &&
      setReadyForShowAttr(true);

  }, [dispatch, productDetails, attributesLoaded]);

  const handleChangeAttr = useCallback(
    (attributesSelectedLast, attrName, attrId) => {
      let newDetails = [];

      if (attrName === "color") {
        // get element based on last attributes
        newDetails = productDetails.details.filter(
          (val) =>
            val.color_id === attrId &&
            val.size_id === attributesSelectedLast.Size[0] &&
            checkEqualArray(
              val.custom_attribute_values,
              attributesSelectedLast.Custom_Value
            )
        );

        // get first element
        if (newDetails.length === 0)
          newDetails = productDetails.details.filter(
            (val) =>
              val.color_id === attrId &&
              getConditionsForPrimaryAttr(val, attrName, attributesSelectedLast)
          );
      } else if (attrName === "size") {
        // get element based on last attributes
        newDetails = productDetails.details.filter(
          (val) =>
            val.color_id === attributesSelectedLast.Color[0] &&
            val.size_id === attrId &&
            checkEqualArray(
              val.custom_attribute_values,
              attributesSelectedLast.Custom_Value
            )
        );

        // get first element
        if (newDetails.length === 0)
          newDetails = productDetails.details.filter(
            (val) =>
              val.size_id === attrId &&
              getConditionsForPrimaryAttr(val, attrName, attributesSelectedLast)
          );
      } else {
        // get element based on last attributes
        newDetails = productDetails.details.filter(
          (val) =>
            val.color_id === attributesSelectedLast.Color[0] &&
            val.size_id === attributesSelectedLast.Size[0] &&
            val.custom_attribute_values.includes(attrId) &&
            checkEqualArray(
              val.custom_attribute_values,
              attributesSelectedLast.Custom_Value
            )
        );

        // get first element
        if (newDetails.length === 0)
          newDetails = productDetails.details.filter(
            (val) =>
              val.custom_attribute_values.includes(attrId) &&
              getConditionsForPrimaryAttr(val, attrName, attributesSelectedLast)
          );
      }

      setAttributesSelected({
        Color: [newDetails[0].color_id],
        Size: [newDetails[0].size_id],
        Custom_Value: newDetails[0].custom_attribute_values,
      });

      getAttributesAvailable(
        newDetails[0],
        productDetails.priority_attr,
        priorityAttrIds
      );

      setLocalDetailsSelected(newDetails[0]);

      setGalleryImage(productDetails?.img ?? null); // set product image
      setQuantity(1); // reset Quantity
    },
    [dispatch, productDetails, priorityAttrIds]
  );

  useEffect(() => {
    // get product from server
    const fetchData = async () => {
      const id = slug.split("-").pop();
      dispatch(loadSingleProductAsync({ auth, dynamicState, id }));
    }

    if (!productDetails?.id) fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (productDetails?.id && attributesLoaded) {

      let priorityAttrIdsParam = custom_attributes.filter(
        (val) => val.id === parseInt(productDetails.priority_attr)
      )[0];

      setAllDetailsProduct();
      setPriorityAttr(productDetails.priority_attr);
      setPriorityAttrIds(priorityAttrIdsParam);
      setGalleryImage(productDetails?.img);
      setLocalDetailsSelected(detailsSelected);

      setAttributesSelected({
        Color: [detailsSelected.color_id],
        Size: [detailsSelected.size_id],
        Custom_Value: detailsSelected.custom_attribute_values,
      });

      getAttributesAvailable(
        detailsSelected,
        productDetails.priority_attr,
        priorityAttrIdsParam
      );

      setQuantity(1); // reset Quantity


    }
  }, [dispatch, detailsSelected, attributesLoaded]);

  useEffect(() => {

    if (!isLoading && productDetails?.id && typeof window !== 'undefined') {
      // textDesc = truncate(155, stripHtml(getValByLang(productDetails.description, language)));
      // pageTitle = truncate(60, getValByLang(productDetails.name, language));
      window.prerenderReady = true;
    }

  }, [isLoading, productDetails]);


  return isLoading ? (
    <CircularProgress className="product-preloader-position" />
  ) : !productDetails?.id ? (
    <Box sx={{ p: 8 }}>
      <Translation data="store.not_found_any_product" />{" "}
    </Box>
  ) : (
    <Container className="page_size">
      <Helmet>
        <title>{truncate(60, getValByLang(productDetails.name, language))}</title>
        <meta name="description" content={truncate(155, stripHtml(getValByLang(productDetails.description, language)))} />
        <meta name="robots" content="index,follow" />
        <meta property="og:title" content={getValByLang(productDetails.name, language)} />
        <meta property="og:description" content={stripHtml(getValByLang(productDetails.description, language))} />
        <meta property="og:image" content={productDetails.img} />
        <meta property="og:url" content={`${window.location.origin}/product/${getValByLang(productDetails.slug, language)}`} />
        <meta name="twitter:title" content={getValByLang(productDetails.name, language)} />
        <meta name="twitter:description" content={stripHtml(getValByLang(productDetails.description, language))} />
        <meta name="twitter:image" content={productDetails.img} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={`${window.location.origin}/product/${getValByLang(productDetails.slug, language)}`} />
        <link rel="canonical" href={`${window.location.origin}/product/${getValByLang(productDetails.slug, language)}`} />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: getValByLang(productDetails.name, language),
          image: productDetails.img,
          description: getValByLang(productDetails.description, language),
          // add additional properties as needed 

          offers: {
            '@type': 'Offer',
            priceCurrency: 'AED',
            price: getPrice(localDetailsSelected),
            availability: 'https://schema.org/InStock',
            itemCondition: 'https://schema.org/NewCondition',
            seller: {
              '@type': 'Organization',
              name: productDetails.sellerInfo?.name || ''
            }
          }

        })}</script>
      </Helmet>
      <Box sx={{ my: 2 }}>
        {/* Mobile Layout */}
        <Box className="mobile-product-layout" sx={{ display: { xs: 'block', md: 'none' } }}>
          {/* 1. Navigation */}
          <Box className="mobile-navigation-section" sx={{ mb: 0 }}>
            <BreadCrumbsProduct
              navigate={navigate}
              name={productDetails.name}
              language={language}
            />
          </Box>

          {/* 2. Brand and Title */}
          <Box className="mobile-product-header" sx={{ mb: 2, px: 1 }}>
            {readyForShowAttr && productDetails.brands_array?.length > 0 && (
              <Typography variant="body2" className="mobile-brand-name" sx={{ color: 'text.secondary', mb: 0.5 }}>
                {getValByLang(productDetails.brands_array[0]?.name, language)}
              </Typography>
            )}
            <Typography variant="h5" component="h1" className="mobile-product-title" sx={{ fontWeight: 'bold', mb: 1, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
              {getValByLang(productDetails?.name, language)}
            </Typography>
            <Typography variant="h6" className="mobile-product-price" sx={{ color: 'primary.main', fontWeight: 'bold', fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
              <ShowPrice Details={localDetailsSelected} page="single-product" />
            </Typography>
          </Box>

          {/* 3. Images */}
          {productDetails?.id && localDetailsSelected?.id > 0 && (
            <Box className="mobile-product-images" sx={{ mb: 3 }}>
              <Swiper
                modules={[Pagination, Navigation]}
                pagination={{
                  clickable: true,
                  dynamicBullets: true
                }}
                navigation={true}
                spaceBetween={0}
                slidesPerView={1}
                loop={false}
                className="mobile-image-carousel"
                style={{ width: '100%' }}
              >
                {/* Main Product Image */}
                <SwiperSlide>
                  <Box
                    sx={{
                      width: '100%',
                      height: { xs: '300px', sm: '400px' },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1e1e1e' : '#f8f9fa'
                    }}
                  >
                    <img
                      src={productDetails?.img}
                      alt="Product"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        maxWidth: '100%',
                        maxHeight: '100%'
                      }}
                    />
                  </Box>
                </SwiperSlide>

                {/* Additional Images */}
                {localDetailsSelected?.images && localDetailsSelected.images.length > 0 &&
                  localDetailsSelected.images.map((image, idx) => (
                    <SwiperSlide key={idx}>
                      <Box
                        sx={{
                          width: '100%',
                          height: { xs: '300px', sm: '400px' },
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1e1e1e' : '#f8f9fa'
                        }}
                      >
                        <img
                          src={image.url}
                          alt={`Product ${idx + 1}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            maxWidth: '100%',
                            maxHeight: '100%'
                          }}
                        />
                      </Box>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </Box>
          )}

          {/* 4. Seller Info */}
          {productDetails.sellerInfo && productDetails.sellerInfo?.length > 0 && (
            <Box className="mobile-seller-section" sx={{ mb: 3, px: 1 }}>
              <SellerProduct sellerInfo={productDetails.sellerInfo[0]} language={language} />
            </Box>
          )}

          {/* 5. Product Attributes and Add to Cart */}
          <Box className="mobile-attributes-cart-section" sx={{ mb: 3, px: 1 }}>
            {readyForShowAttr && (
              <Box className={
                (productDetails.colors_array?.length > 0 ||
                  productDetails.sizes_array?.length > 0 ||
                  productDetails.details[0].custom_attribute_keys?.length > 0)
                  ? "attribute-product mobile-attributes"
                  : ""
              }>
                {/* Color Selection */}
                {productDetails.colors_array?.length > 0 && (
                  <Box className="mobile-color-selection" sx={{ mb: 2 }}>
                    <Typography component="p" sx={{ mb: 1, fontWeight: 'medium' }}>
                      <Translation data="store.color" />
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {productDetails.colors_array.map((val, idx) => {
                        return val ? (
                          <Button
                            variant={
                              attributesSelected.Color.includes(val.id)
                                ? "contained"
                                : "outlined"
                            }
                            disabled={
                              priorityAttr !== "color"
                                ? attributesAvailable.Color.includes(val.id)
                                  ? false
                                  : true
                                : false
                            }
                            size="small"
                            onClick={() =>
                              handleChangeAttr(attributesSelected, "color", val.id)
                            }
                            key={idx}
                            sx={{ minWidth: 'auto', px: 2 }}
                          >
                            {getValByLang(val.name, language)}
                          </Button>
                        ) : null;
                      })}
                    </Box>
                  </Box>
                )}

                {/* Size Selection */}
                {productDetails.sizes_array?.length > 0 && (
                  <Box className="mobile-size-selection" sx={{ mb: 2 }}>
                    <Typography component="p" sx={{ mb: 1, fontWeight: 'medium' }}>
                      <Translation data="store.size" />
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {productDetails.sizes_array.map((val, idx) => {
                        return val ? (
                          <Button
                            variant={
                              attributesSelected.Size.includes(val.id)
                                ? "contained"
                                : "outlined"
                            }
                            disabled={
                              priorityAttr !== "size"
                                ? attributesAvailable.Size.includes(val.id)
                                  ? false
                                  : true
                                : false
                            }
                            size="small"
                            onClick={() =>
                              handleChangeAttr(attributesSelected, "size", val.id)
                            }
                            key={idx}
                            sx={{ minWidth: 'auto', px: 2 }}
                          >
                            {getValByLang(val.name, language)}
                          </Button>
                        ) : null;
                      })}
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            {/* Add to Cart Button */}
            <Box className="mobile-add-to-cart" sx={{ mt: 2 }}>
              <AddToCartButton
                product={productDetails}
                type="single_product"
                quantity={quantity}
                setQuantity={setQuantity}
                detail={localDetailsSelected}
              />
            </Box>
          </Box>

          {/* 6. Description/Specification */}
          <Box className="mobile-description-section" sx={{ mb: 3, px: 1 }}>
            <DescriptionProduct
              language={language}
              readyForShowAttr={readyForShowAttr}
              productDetails={productDetails}
            />
          </Box>

          {/* 7. Banner */}
          <Box className="mobile-banner-section" sx={{ mb: 3, px: 1 }}>
            <Box sx={{ textAlign: "center" }}>
              <Box
                component="img"
                src={bannerSeller}
                alt="Become a Seller Now"
                onClick={() => {
                  window.open(`${allDomain.seller}login`, "_blank");
                }}
                sx={{
                  width: "100%",
                  maxWidth: 400,
                  cursor: "pointer",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              />
            </Box>
          </Box>

          {/* 8. Reviews */}
          {productDetails.review !== 0 && (
            <Box className="mobile-reviews-section" sx={{ mb: 3, px: 1 }}>
              <Review
                review={productDetails.review}
                productReviews={productReviews}
                auth={auth}
                dynamicState={dynamicState}
                id={id}
              />
            </Box>
          )}

          {/* 9. Related Products */}
          <Box className="mobile-related-section">
            <ProductRelated
              setReadyForShowAttr={setReadyForShowAttr}
              auth={auth}
              dynamicState={dynamicState}
              store_id={productDetails?.store_id}
              language={language}
            />
          </Box>
        </Box>

        {/* Desktop Layout */}
        <Grid container spacing={4} sx={{ display: { xs: 'none', md: 'flex' } }}>
          {productDetails?.id && localDetailsSelected?.id > 0 && (
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
              <ImageProduct
                galleryImage={galleryImage}
                setGalleryImage={setGalleryImage}
                productImg={productDetails?.img}
                detailsSelected={localDetailsSelected}
              />
              <Box className="display-cart-with-quantity" justifyContent={'space-around'} display={"flex"} sx={{ mt: 3, gap: 2 }}>
                <AddToCartButton product={productDetails} type="single_product" quantity={quantity} setQuantity={setQuantity} detail={localDetailsSelected} />
              </Box>

              {productDetails.review !== 0 && (
                <Review
                  review={productDetails.review}
                  productReviews={productReviews}
                  auth={auth}
                  dynamicState={dynamicState}
                  id={id}
                />
              )}
            </Grid>
          )}

          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Box sx={{ display: "inline-flex" }}>
              <BreadCrumbsProduct
                navigate={navigate}
                name={productDetails.name}
                language={language}
              />
            </Box>

            <AllDetails
              readyForShowAttr={readyForShowAttr}
              handleChangeAttr={handleChangeAttr}
              productDetails={productDetails}
              localDetailsSelected={localDetailsSelected}
              attributesSelected={attributesSelected}
              priorityAttr={priorityAttr}
              language={language}
              attributesAvailable={attributesAvailable}
              sellerInfo={productDetails.sellerInfo}
            />
          </Grid>

          <ProductRelated
            setReadyForShowAttr={setReadyForShowAttr}
            auth={auth}
            dynamicState={dynamicState}
            store_id={productDetails?.store_id}
            language={language}
          />
        </Grid>
      </Box>
    </Container>
  );
}
